import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    buttonContainer: {
        borderStyle: "dashed",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden"
    },
    imageBackground: {
        width: "100%",
        height: 200,
        justifyContent: "center",
        alignItems: "center"
    },
    contentContainer: {
        alignItems: "center",
        justifyContent: "center"
    },
    emptyContentContainer: {
        alignItems: "center",
        justifyContent: "center"
    }
});

export default stylesheet;
